// Site-wide context: site info, categories
import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchSiteInfo, fetchCategories } from "@/lib/api";

const SiteCtx = createContext({ site: null, categories: [], loading: true });

export const SiteProvider = ({ children }) => {
  const [site, setSite] = useState(null);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancel = false;
    (async () => {
      try {
        const [s, c] = await Promise.all([fetchSiteInfo(), fetchCategories()]);
        if (!cancel) {
          setSite(s);
          setCategories(c);
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Site load failed", e);
      } finally {
        if (!cancel) setLoading(false);
      }
    })();
    return () => {
      cancel = true;
    };
  }, []);

  return (
    <SiteCtx.Provider value={{ site, categories, loading }}>
      {children}
    </SiteCtx.Provider>
  );
};

export const useSite = () => useContext(SiteCtx);
